// UI strings — nav, labels, ctas, footer
const I18N = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      tax: "Tax",
      compliance: "Compliance",
      advisory: "Advisory",
      insights: "Insights",
      about: "About us",
      pricing: "Pricing",
      contact: "Contact",
      search: "Search",
      menu: "Menu",
      close: "Close",
    },
    pageNames: {
      home: "Home",
      about: "About us",
      "services-pricing": "Services & Pricing",
      contact: "Contact us",
      "melbourne-accounting-firm": "Melbourne Accounting Firm",
      "brisbane-accounting-firm": "Brisbane Accounting Firm",
      "canterbury-accounting": "Canterbury Accounting",
      "box-hill-accountant": "Accountant Box Hill",
      "chinese-accountants-aus": "Chinese-speaking Accountants",
      "melbourne-accounting-tax": "Melbourne Accounting & Tax",
      "individual-tax": "Personal Tax Services",
      "melbourne-company-personal-tax": "Company Tax Services",
      "company-tax": "Company Tax Services",
      "small-business-tax": "Small Business Tax Services",
      "business-tax": "How Australian Businesses File Tax",
      "tax-deadlines": "Tax Deadlines",
      "bas-lodgement": "Business Activity Statement (BAS) Lodgement Service",
      "gst-registration": "Good and Services Tax (GST) Registration",
      "tfn": "Apply for Tax File Number (TFN)",
      "abn": "Apply for Australian Business Number (ABN)",
      "company-setup": "Company Setup & Business Plan",
      "smsf": "Self Managed Super Fund (SMSF) Set up",
      "family-trust": "Family Trust Guide",
      "negative-gearing": "Negative Gearing",
      "home-office-tax": "Working from Home Tax",
      "business-travel-tax": "Business Travel Tax",
      "insights": "Insights",
      "sole-trader-vs-company": "Sole Trader vs Pty Ltd: Choosing Your Business Structure in Australia",
      "division-7a-director-loans": "Division 7A: Can a Director Withdraw Cash From the Company Account?",
      "cash-flow-management": "Cash Flow Management Guide for Australian Small Businesses",
      "single-touch-payroll-stp": "Single Touch Payroll (STP) Explained — How It Works in Australia",
      "hospitality-tax-deductions": "Tax Deductions for Australian Hospitality Workers — The Complete Guide",
      "tpar-taxable-payments": "What is the Taxable Payments Annual Report (TPAR)?",
      "car-personal-or-company": "Buying a Car in Australia — Personal or Company Name?",
    },
    featuredLabels: {
      "smsf": "SMSF Set Up",
    },
    groupLabels: {
      services: "Practice",
      tax: "Tax",
      compliance: "Compliance",
      advisory: "Advisory",
      insights: "Insights",
    },
    cta: {
      schedule: "Schedule a consultation",
      learnMore: "Learn more",
      explore: "Explore services",
      getInTouch: "Get in touch",
      watchFilm: "Watch film",
      makeItHappen: "Make it happen with ABS",
      readMore: "Read more",
      viewPricing: "View pricing",
      contactUs: "Contact us",
    },
    home: {
      heroSubtitle: "Tailored accounting, tax & advisory — built on twelve years of trust.",
      marquee: "Accounting · Taxation · SMSF · Audit · Bookkeeping · BAS / GST · Family Office · Advisory · ",
    },
    footer: {
      tagline: "Family-owned. Boutique. Trusted by Australian businesses since 2012.",
      offices: "Offices",
      followUs: "Follow us",
      copyright: "© 2025 Absolute Business Services (ABS) Solutions. All rights reserved.",
      quickLinks: "Quick links",
      explore: "Explore",
      legal: "Privacy · Terms · Cookies",
    },
    misc: {
      onThisPage: "On this page",
      hours: "Office hours",
      address: "Address",
      phone: "Phone",
      mobile: "Mobile",
      email: "Email",
      backToTop: "Back to top",
      cookies: "We use cookies to analyse traffic and improve your experience.",
      cookiesAccept: "Accept",
      languageEN: "English",
      languageZH: "中文",
      featuredInsight: "Featured insight",
      insight: "Insight",
      readingTime: "Reading time",
      relatedServices: "Related services",
      ourTeam: "Our team",
      whyChoose: "Why choose ABS",
      allPrices: "All prices include GST.",
      quote: "The only way to do great work is to love what you do.",
      quoteAuthor: "Steve Jobs",
    },
  },
  zh: {
    nav: {
      home: "首页",
      services: "服务",
      tax: "税务",
      compliance: "合规",
      advisory: "咨询",
      insights: "洞察",
      about: "关于我们",
      pricing: "定价",
      contact: "联系我们",
      search: "搜索",
      menu: "菜单",
      close: "关闭",
    },
    pageNames: {
      home: "首页",
      about: "关于我们",
      "services-pricing": "我们的收费价格",
      contact: "联系我们",
      "melbourne-accounting-firm": "墨尔本会计师事务所",
      "brisbane-accounting-firm": "布里斯班会计师事务所",
      "canterbury-accounting": "Canterbury会计服务",
      "box-hill-accountant": "Box Hill 会计师",
      "chinese-accountants-aus": "澳洲华人会计师事务所",
      "melbourne-accounting-tax": "墨尔本会计报税",
      "individual-tax": "个人报税服务",
      "melbourne-company-personal-tax": "公司报税服务",
      "company-tax": "专业公司报税服务",
      "small-business-tax": "小生意报税服务",
      "business-tax": "澳洲企业怎么报税",
      "tax-deadlines": "澳洲报税截止日期",
      "bas-lodgement": "商业活动报表（BAS）申报服务",
      "gst-registration": "商品及服务税（GST）注册",
      "tfn": "申请税号（TFN）",
      "abn": "申请澳洲商业号码（ABN）",
      "company-setup": "公司架构设立与商业计划服务",
      "smsf": "自管养老金（SMSF）设立",
      "family-trust": "澳洲家庭信托全攻略",
      "negative-gearing": "澳洲负扣税全面解析",
      "home-office-tax": "居家办公怎么报税",
      "business-travel-tax": "公务出差费用如何报税",
      "insights": "深度洞察",
      "sole-trader-vs-company": "澳洲做生意选择个人还是公司",
      "division-7a-director-loans": "Division 7A：公司账户的钱，老板可以随便转出来吗",
      "cash-flow-management": "澳洲小型企業現金流管理指南",
      "single-touch-payroll-stp": "什么是单一触点工资系统（STP）以及它是如何运作的",
      "hospitality-tax-deductions": "澳洲餐饮从业者报税抵扣完整指南",
      "tpar-taxable-payments": "什么是应纳税额年度申报表（TPAR）",
      "car-personal-or-company": "澳洲买车放在私人还是公司名下",
      "payday-super": "Payday Super 已正式实施：澳洲雇主现在必须做的几件事",
    },
    featuredLabels: {
      "smsf": "SMSF 设立",
    },
    groupLabels: {
      services: "事务所",
      tax: "税务",
      compliance: "合规",
      advisory: "咨询",
      insights: "洞察",
    },
    cta: {
      schedule: "预约咨询",
      learnMore: "了解更多",
      explore: "查看所有服务",
      getInTouch: "联系我们",
      watchFilm: "观看影片",
      makeItHappen: "与 ABS 共创未来",
      readMore: "阅读更多",
      viewPricing: "查看收费",
      contactUs: "联系我们",
    },
    home: {
      heroSubtitle: "为澳洲个人与企业量身定制的会计、税务与咨询服务——基于十二年的信赖。",
      marquee: "会计 · 税务 · SMSF · 审计 · 簿记 · BAS / GST · 家族办公室 · 咨询 · ",
    },
    footer: {
      tagline: "家族经营，精品事务所。自 2012 年起服务澳大利亚企业。",
      offices: "办公地点",
      followUs: "关注我们",
      copyright: "© 2025 Absolute Business Services (ABS) Solutions. 版权所有。",
      quickLinks: "快速链接",
      explore: "浏览",
      legal: "隐私 · 条款 · Cookie",
    },
    misc: {
      onThisPage: "本页导览",
      hours: "营业时间",
      address: "地址",
      phone: "座机",
      mobile: "手机",
      email: "邮箱",
      backToTop: "返回顶部",
      cookies: "我们使用 Cookie 分析流量并优化您的体验。",
      cookiesAccept: "接受",
      languageEN: "English",
      languageZH: "中文",
      featuredInsight: "精选洞察",
      insight: "洞察",
      readingTime: "阅读时长",
      relatedServices: "相关服务",
      ourTeam: "我们的团队",
      whyChoose: "为什么选择 ABS",
      allPrices: "所有价格均含 GST。",
      quote: "把工作做到极致的唯一方法是热爱你所做的事。",
      quoteAuthor: "史蒂夫·乔布斯",
    },
  },
};

export default I18N;
